import { from, map, switchMap } from 'rxjs';

export class ImageBase64Formater {
  static extensionMap: { [key: string]: string } = {
    '/': 'jpg',
    i: 'png',
    R: 'gif',
    U: 'webp',
    P: 'svg',
  };
  static dataImage = 'data:image/';
  static imageStart = 'image/';

  static formater(base64: string | undefined): string | null {
    if (!base64) return null;

    const base = ';base64,' + base64;
    const extension = this.extensionMap[base64.charAt(0)] || 'png';

    return this.dataImage + extension + base;
  }

  static createFile(base64: string | undefined) {
    if (!base64) return;

    const formaterBase64 = this.formater(base64);

    if (!formaterBase64) return;

    const type = this.imageStart + this.extensionMap[base64.charAt(0)] || 'png';

    const file$ = from(fetch(formaterBase64)).pipe(
      switchMap((response) => from(response.blob())),
      map((blob) => new File([blob], 'image', { type }))
    );

    return file$;
  }
}
